<div class="category-select-trigger" [matMenuTriggerFor]="readOnly ? null : categoryMenu" role="button" tabindex="0" [attr.aria-label]="selectedCategory?.name ?? ('request_v2.category.select_category' | translate)" [class.readonly]="readOnly">
  <span class="category-name-display">{{ selectedCategory?.name ?? ('request_v2.category.select_a_category_placeholder' | translate) }}</span>
  <mat-icon class="chevron-icon" *ngIf="!readOnly">keyboard_arrow_down</mat-icon>
</div>

<mat-menu #categoryMenu="matMenu" panelClass="category-select-menu-panel">
  <div class="filter-title">{{ 'request_v2.category.select_category' | translate }}</div>
  <mat-divider></mat-divider>
  <div class="category-menu">
    <div class="category-option" 
        *ngFor="let category of categories" 
        (click)="onCategorySelect(category._id)">
      <div class="category-item">
        {{ category.name }}
      </div>
    </div>
    <div *ngIf="!categories || categories.length === 0" class="no-categories-message-container" (click)="$event.stopPropagation()">
      <span class="no-categories-message">{{ 'request_v2.category.no_categories_available' | translate }}</span>
    </div>
  </div>
</mat-menu>
